<script>
    import {pad0} from "../../lib/lib.js";

    export let value;
    export let required = false;
    export let disabled = false;

    let year;
    let month;
    let date;
    let years = [];
    let months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    let dates = [];
    let maxDates = 31;

    const initialize = () => {
        let today = new Date();
        let dtYear = ~~today.getFullYear();
        let i;
        for (i = dtYear - 85; i <= dtYear - 17; i++) {
            years.push(i);
        }
        for (i = 1; i < 32; i++) {
            dates.push(i);
        }

        if (value && (!year || !month || !date)) {
            let arr = value.split('-');
            year = ~~arr[0];
            month = ~~arr[1];
            date = ~~arr[2];
            setMaxDates();
        } else {
            // set default year
            year = dtYear - 40;
        }
    }

    const setMaxDates = () => {
        maxDates = new Date(parseInt(year), parseInt(month), 0).getDate();
    }

    const onChange = () => {
        if (year && month) {
            setMaxDates();
        }
    }

    initialize();

    $: if (year && month && date) {
        value = `${year}-${pad0(month)}-${pad0(date)}`;
    } else {
        value = null;
    }
</script>

<div class="birthday-control">
    <select class="form-select year" bind:value="{ year }" on:change={ onChange } {required} {disabled}>
        <option value="">year</option>
        {#each years as item}
            <option value="{ item }">{ item }</option>
        {/each}
    </select>
    <select class="form-select month" bind:value="{ month }" on:change={ onChange } {required} {disabled}>
        <option value="">month</option>
        {#each months as item, index}
            <option value="{ index + 1 }">{ item }</option>
        {/each}
    </select>
    <select class="form-select date" bind:value="{ date }" {required} {disabled}>
        <option value="">date</option>
        {#each dates as item}
            {#if item <= maxDates}
                <option value="{ item }">{ item }</option>
            {/if}
        {/each}
    </select>
</div>

<style>
    .birthday-control {
        display: flex;
    }

    .birthday-control .year {
        width: 85px;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        border-right: none;
    }

    .birthday-control .month {
        border-radius: 0;
        width: calc(100% - 170px);
    }

    .birthday-control .date {
        width: 85px;
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
    }
</style>